import { render, staticRenderFns } from "./GlobalDashboardCardChart.vue?vue&type=template&id=31639fe6&"
import script from "./GlobalDashboardCardChart.vue?vue&type=script&lang=js&"
export * from "./GlobalDashboardCardChart.vue?vue&type=script&lang=js&"
import style0 from "./GlobalDashboardCardChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports